import 'react-image-crop/dist/ReactCrop.css';
import { DialogSection } from '~/components/dialogs/dialog-section.component';
import { StyledModal as Dialog } from '~/components/dialogs/dialog.style';

export interface LMIProofDocSkipConfirmationDialogProps {
  onSkip: () => void;
  onCancel: () => void;
}

export const LMIProofDocSkipConfirmationDialog = ({
  onSkip,
  onCancel,
}: LMIProofDocSkipConfirmationDialogProps) => {
  return (
    <Dialog isOpen size="small" onDismiss={onCancel} aria-label="Skip this step?">
      <Dialog.Header title="Skip this step?" onClose={onCancel} />
      <DialogSection>
        If you skip this step, any image or document you have uploaded will be automatically
        deleted.
      </DialogSection>
      <Dialog.FooterStacked
        primaryText="Skip and delete uploads"
        onSubmit={onSkip}
        secondaryText="Cancel"
        onCancel={onCancel}
      />
    </Dialog>
  );
};
